import React from 'react';

const Partners = () => {
    const partners = [
        {
            name: 'Zarposh Collection',
            logo: 'https://zarposhcollection.com/cdn/shop/files/Layer_1.svg?v=1751441942&width=1020',
            className: 'h-12 w-auto grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-300'
        },
        {
            name: 'Emral',
            logo: 'https://emral.pk/cdn/shop/files/new-logo-emral.jpg?v=1738232674&width=135',
            className: 'h-10 w-auto grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-300'
        }
    ];

    return (
        <section id="partners" className="w-full py-20 bg-white border-t border-slate-100 scroll-mt-24">
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="flex flex-col items-center gap-12">
                    <div className="flex flex-col items-center gap-3">
                        <span className="text-blue-600 font-bold uppercase tracking-[0.2em] text-[10px]">Trusted By Leaders</span>
                        <h2 className="text-3xl font-extrabold text-slate-900 tracking-tight">Our Partners</h2>
                    </div>

                    <div className="flex flex-wrap items-center justify-center gap-16 md:gap-24">
                        {partners.map((partner) => (
                            <div key={partner.name} className="flex items-center justify-center group cursor-pointer p-4 rounded-2xl hover:bg-slate-50 transition-colors">
                                <img
                                    src={partner.logo}
                                    alt={partner.name}
                                    className={partner.className}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Partners;
